var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0074D9",
    fillRule: "evenodd",
    d: "M5.793 8.878a.75.75 0 0 1-.385.645v1.64h-.77v-1.64a.748.748 0 0 1-.385-.645c0-.42.344-.761.77-.761.424 0 .77.34.77.761zM10 6.965v5.393A1.15 1.15 0 0 1 8.845 13.5h-7.69A1.15 1.15 0 0 1 0 12.358V6.965c0-.63.518-1.143 1.155-1.143h.018V4.308C1.173 2.208 2.9.5 5.023.5c2.122 0 3.85 1.708 3.85 3.808v1.518A1.147 1.147 0 0 1 10 6.965zM1.943 5.822V4.308c0-1.68 1.381-3.046 3.08-3.046 1.698 0 3.08 1.366 3.08 3.046v1.514h-6.16z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockBlue);
export default __webpack_public_path__ + "static/media/lock-blue.b34de98cc5e782847f305918a50148c0.svg";
export { ForwardRef as ReactComponent };